window.CookieHandler = {
    getCookieString: (cookie_name: string = "") => {
        let res = document.cookie;

        if(cookie_name != "") {
            res.split(";").map((cookie_set) => {
                const [key, val] = cookie_set.trim().split("=");

                if(key == cookie_name) {
                    res = [key, val].join("=")
                }
            })
        };

        return res;
    },

    getCookieObject: (cookie_name: string = "") => {
        let res: stringStringMap = {};
        
        document.cookie.split(";").map((cookie_set) => {
            const [key, val] = cookie_set.trim().split("=");

            if(key != "" && val != undefined) {
                res[key] = val;

                if(cookie_name != "" && key == cookie_name) {
                    let temp = {};
                    temp[key] = val;
                    return temp;
                }
            }


        });

        return res;
    },

    setCookie: (
        cookie_key: string, 
        cookie_value: string = "", 
        days_duration: number = 365, 
        cookie_path: string = "/"
    ) => {
        let curr_date = new Date();
        curr_date.setTime( curr_date.getTime() + (days_duration * 24 * 60 * 60 * 1000) );

        document.cookie = cookie_key + "=" + cookie_value + ";expires=" + curr_date.toUTCString() + window.Paths.DOMAIN + ";path=" + cookie_path;
    },

    isSet: (cookie_name: string) => {
        return window.CookieHandler.getCookieObject(cookie_name).hasOwnProperty(cookie_name);
    },

    deleteCookie: (cookie_key: string) => {
        window.CookieHandler.setCookie(cookie_key, "", -1);
    },

    deleteAll: () => {
        Object.keys(window.CookieHandler.getCookieObject()).map((cookie_key) => {
            window.CookieHandler.setCookie(cookie_key, "", -1);
        })
    },
}
